import { styled } from '@lichtblick/styled';
import { Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S};
`;
